import { useGeneratorFilterStore } from '@/state/generator-filter-store';
import { useEffect } from 'react';

export function useStyleFilterFromParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const filterGroupId = urlParams.get('filterGroupId');

  const { filterGroupList, setCurrentFilterGroup } = useGeneratorFilterStore();

  useEffect(() => {
    if (filterGroupId && filterGroupList?.length && setCurrentFilterGroup) {
      setCurrentFilterGroup(filterGroupList?.find((filter) => filter.id === Number(filterGroupId)) ?? null);
    }
  }, [filterGroupId, setCurrentFilterGroup, filterGroupList]);
}
